// The app asks for a token for itself ("self scope"), so the audience of the token is the single-page application's client ID.
// The backend of the same environment lists that ID as an allowed audience and checks the group claim.
export function entra(clientId: string) {
  return {
    tenantId: '2146c4ae-6471-40a8-b821-2774c8057963',
    clientId,
    scopes: [`${clientId}/.default`],
  };
}

// The single-page application registration of each environment.
export const SPA_CLIENT_IDS = {
  dev: '36de2476-56a2-45b0-8f92-76573a6c0efc',
  test: '56a2b4bc-270d-447d-88a1-2d8426421812',
  prod: 'e1976788-7f12-42a0-b6d5-b7877e3c83d4',
};
